import type { Page } from './NavBar'

const NAV_ITEMS: { id: Page; label: string }[] = [
  { id: 'chat',        label: 'Chat' },
  { id: 'candidates',  label: 'Candidates' },
  { id: 'shortcuts',   label: 'Shortcuts' },
  { id: 'scene-list',  label: 'Scene list' },
  { id: 'scene-map',   label: 'Scene map' },
  { id: 'scene-data',  label: 'Scene data' },
  { id: 'shows',       label: 'Shows' },
  { id: 'fans',        label: 'Fans' },
  { id: 'jontha-info', label: 'Jontha info' },
  { id: 'mod-log',     label: 'Modification log' },
  { id: 'sync',        label: 'Sync' },
]

interface SideNavProps {
  page: Page
  open: boolean
  onNavigate: (page: Page) => void
  onClose: () => void
}

export default function SideNav({ page, open, onNavigate, onClose }: SideNavProps) {
  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.5)',
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',
          transition: 'opacity 0.2s ease',
          zIndex: 100,
        }}
      />

      {/* Nav panel */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          width: 220,
          background: 'var(--bg)',
          borderRight: '1px solid rgba(255,255,255,0.08)',
          transform: open ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.22s ease',
          zIndex: 101,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto',
          paddingTop: 12,
          paddingBottom: 16,
        }}
      >
        {NAV_ITEMS.map((item) => {
          const active = page === item.id
          return (
            <button
              key={item.id}
              onClick={() => { onNavigate(item.id); onClose() }}
              style={{
                padding: '11px 20px',
                textAlign: 'left',
                fontSize: '14px',
                fontWeight: active ? 600 : 400,
                color: active ? 'var(--accent)' : 'var(--text-muted)',
                background: active ? 'rgba(255,255,255,0.06)' : 'transparent',
                borderLeft: `2px solid ${active ? 'var(--accent)' : 'transparent'}`,
                transition: 'color 0.12s, background 0.12s',
              }}
            >
              {item.label}
            </button>
          )
        })}
      </div>
    </>
  )
}
